import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[100svh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_e5acce0f3a84e49a80b0fccaf666217b_4092c584.jpg"
          alt="Creighton Investments Ltd – Private Wealth Management Excellence"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark Overlay — stronger on mobile for readability with cropped image */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55 md:from-black/35 md:via-black/20 md:to-black/40" />
        {/* Subtle gold accent overlay */}
        <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/15 md:from-primary-900/10 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-5 md:px-12 py-24 md:py-40">
        <div className="max-w-3xl">
          {/* Tagline */}
          <div className="inline-flex items-center gap-2 bg-primary-500/90 backdrop-blur-sm text-white text-[11px] md:text-xs uppercase tracking-[3px] font-semibold px-3.5 py-1.5 md:px-4 md:py-2 rounded-full mb-6 md:mb-8">
            <span className="w-1.5 h-1.5 bg-white rounded-full" />
            Creighton Investments Ltd — Est. 2016
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-[1.08] md:leading-[1.05] mb-5 md:mb-6 tracking-tight">
            Capital That<br />
            <span className="text-primary-300">Builds the Future</span>
          </h1>

          {/* Subheadline */}
          <p className="text-sm md:text-xl text-white/80 font-light leading-relaxed max-w-xl mb-8 md:mb-10">
            A diversified UK investment firm deploying institutional capital across real estate, renewable energy, oil &amp; gas, digital assets, and modern medical equipment — delivering enduring value since 2016.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
            <Link
              to="/portfolio"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-xs md:text-sm uppercase tracking-[2px] font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Portfolio
              <i className="ri-arrow-right-line text-base md:text-lg" />
            </Link>
            <Link
              to="/investor-relations"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/40 hover:border-white text-white text-xs md:text-sm uppercase tracking-[2px] font-semibold px-6 md:px-8 py-3.5 md:py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer hover:bg-white/10"
            >
              Investor Relations
            </Link>
          </div>
        </div>

        {/* Floating Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mt-14 md:mt-28">
          {[
            { value: '€2.4B+', label: 'Assets Under Management' },
            { value: '47', label: 'Active Investments' },
            { value: '18', label: 'Countries Worldwide' },
            { value: '12.8%', label: 'Avg Annual Return' },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl px-4 md:px-5 py-4 md:py-5 text-center hover:bg-white/15 transition-all duration-300"
            >
              <p className="text-2xl md:text-4xl font-heading font-bold text-white mb-0.5 md:mb-1">
                {stat.value}
              </p>
              <p className="text-white/60 text-[10px] md:text-xs uppercase tracking-[1.5px] font-medium leading-tight">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 md:bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/40 text-[10px] uppercase tracking-[3px]">Scroll</span>
        <div className="w-px h-8 md:h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}